import FocusableIconButton from '@components/FocusableIconButton';
import { useAgreementContext } from '@context/Agreement';
import { useEffect } from 'react';
import {
  AGREE_ALL_IN_SPECIFIC_BUTTON,
  AGREE_IDENTIFICATION_INFORMATION_COLLECTION,
  AGREE_PERSONAL_INFORMATION_PROVISION,
  AGREE_PERSONAL_INFORMATION_USAGE,
  AGREE_SENSITIVE_INFORMATION_COLLECTION
} from '../../../focuskey';
import SpecificAgreementButton from '../SpecificAgreementButton';
import * as styles from './styles';
const SpecificFourAgreementButtons = () => {
  const { checkAndStartTreatment, setWholeAgreement, focusAgreeAll } =
    useAgreementContext();

  useEffect(() => {
    focusAgreeAll();
  }, [focusAgreeAll]);

  return (
    <div css={styles.buttonContainer}>
      <SpecificAgreementButton index={0} focusKey={AGREE_PERSONAL_INFORMATION_USAGE} />
      <SpecificAgreementButton
        index={1}
        focusKey={AGREE_PERSONAL_INFORMATION_PROVISION}
      />
      <SpecificAgreementButton
        index={2}
        focusKey={AGREE_IDENTIFICATION_INFORMATION_COLLECTION}
      />
      <SpecificAgreementButton
        index={3}
        focusKey={AGREE_SENSITIVE_INFORMATION_COLLECTION}
      />

      <FocusableIconButton
        iconType="check"
        focusKey={AGREE_ALL_IN_SPECIFIC_BUTTON}
        onEnterPress={checkAndStartTreatment}
        onFocus={setWholeAgreement}
      >
        모든 약관 동의
      </FocusableIconButton>
    </div>
  );
};

export default SpecificFourAgreementButtons;
